<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
import { authMixin } from './mixins/authMixin.js'
export default {
  name: 'app',
  mixins: [authMixin],
  components: {
  },
  data: () => {
    return {
    }
  },
  methods: {
    extractAccessToken (url) {
      return this.getSubString(url, '=', '&');
    },
    setAccessToken (url) {
      this.accessToken = this.extractAccessToken(url);
    }
  },
  mounted: function () {
    const curl = window.location.href;
    if (curl.includes('access_token')) {
      this.setAccessToken(curl);
    }
    if(this.accessToken){
      this.isLoggedIn = true;
      return this.$router.push({
        name: 'home',
        params: {
          accessToken: this.accessToken
        }
      });
    }
    this.$router.push('login');
  }
}
</script>

<style>
*, *:before, *:after {
  -moz-box-sizing: border-box;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}
html { width: 100%; height: 100%; }
body {
  margin: 0;
  width: 100%;
  height: 100%;
}
svg {
  width: 100%;
}
img {
  max-width: 100%;
  height: auto;
}
p {
  margin: 0;
}
.body-copy {
  margin: 1rem 0;
}
ul {
  margin: 0;
  padding: 0;
  list-style: none;
}
a {
  color: #454F8C;
  text-decoration: none;
  border-bottom: 1px solid;
}
h1,h2,h3,h4 {
  color: #454F8C;
  margin: 1rem 0 .3rem 0;
}
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #6D8CA0;
  background-color: hsla(232,34%,92%,1);
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 56 28' width='56' height='28'%3E%3Cpath fill='%23454f8c' fill-opacity='0.2' d='M56 26v2h-7.75c2.3-1.27 4.94-2 7.75-2zm-26 2a2 2 0 1 0-4 0h-4.09A25.98 25.98 0 0 0 0 16v-2c.67 0 1.34.02 2 .07V14a2 2 0 0 0-2-2v-2a4 4 0 0 1 3.98 3.6 28.09 28.09 0 0 1 2.8-3.86A8 8 0 0 0 0 6V4a9.99 9.99 0 0 1 8.17 4.23c.94-.95 1.96-1.83 3.03-2.63A13.98 13.98 0 0 0 0 0h7.75c2 1.1 3.73 2.63 5.1 4.45 1.12-.72 2.3-1.37 3.53-1.93A20.1 20.1 0 0 0 14.28 0h2.7c.45.56.88 1.14 1.29 1.74 1.3-.48 2.63-.87 4-1.15-.11-.2-.23-.4-.36-.59H26v.07a28.4 28.4 0 0 1 4 0V0h4.09l-.37.59c1.38.28 2.72.67 4.01 1.15.4-.6.84-1.18 1.3-1.74h2.69a20.1 20.1 0 0 0-2.1 2.52c1.23.56 2.41 1.2 3.54 1.93A16.08 16.08 0 0 1 48.25 0H56c-4.58 0-8.65 2.2-11.2 5.6 1.07.8 2.09 1.68 3.03 2.63A9.99 9.99 0 0 1 56 4v2a8 8 0 0 0-6.77 3.74c1.03 1.2 1.97 2.5 2.79 3.86A4 4 0 0 1 56 10v2a2 2 0 0 0-2 2.07 28.4 28.4 0 0 1 2-.07v2c-9.2 0-17.3 4.78-21.91 12H30zM7.75 28H0v-2c2.81 0 5.46.73 7.75 2zM56 20v2c-5.6 0-10.65 2.3-14.28 6h-2.7c4.04-4.89 10.15-8 16.98-8zm-39.03 8h-2.69C10.65 24.3 5.6 22 0 22v-2c6.83 0 12.94 3.11 16.97 8zm15.01-.4a28.09 28.09 0 0 1 2.8-3.86 8 8 0 0 0-13.55 0c1.03 1.2 1.97 2.5 2.79 3.86a4 4 0 0 1 7.96 0zm14.29-11.86c1.3-.48 2.63-.87 4-1.15a25.99 25.99 0 0 0-44.55 0c1.38.28 2.72.67 4.01 1.15a21.98 21.98 0 0 1 36.54 0zm-5.43 2.71c1.13-.72 2.3-1.37 3.54-1.93a19.98 19.98 0 0 0-32.76 0c1.23.56 2.41 1.2 3.54 1.93a15.98 15.98 0 0 1 25.68 0zm-4.67 3.78c.94-.95 1.96-1.83 3.03-2.63a13.98 13.98 0 0 0-22.4 0c1.07.8 2.09 1.68 3.03 2.63a9.99 9.99 0 0 1 16.34 0z'%3E%3C/path%3E%3C/svg%3E");
  display: flex;
  flex-wrap: wrap;
  min-height: 100%;
  font-size: 17px;
  line-height: 1.6;
  text-align: left;
}

.no-select {
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -khtml-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}
.box {
  box-shadow: 4px 4px 29px 6px rgba(4, 15, 41, 0.06), 9px 9px 45px 34px rgba(4, 15, 41, 0.04);
  background: #fff;
  border-radius: 10px;
}
.box-shadow {
  box-shadow: 4px 4px 29px 6px rgba(4, 15, 41, 0.06), 9px 9px 45px 34px rgba(4, 15, 41, 0.04);
}

.flex {
  display: flex;
  flex-wrap: wrap;
}

.m-a-center { justify-content: center; }
.m-a-start { justify-content: flex-start; }
.m-a-end { justify-content: flex-end; }
.m-a-between { justify-content: space-between; }

.s-a-center { align-items: center; }
.s-a-start { align-items: flex-start; }
.s-a-end { align-items: flex-end; }
.s-a-between { align-items: space-between; }

.m-t-0 { margin-top: 0rem; }
.m-t-1 { margin-top: 1rem; }
.m-t-3 { margin-top: 3rem; }
.m-t-5 { margin-top: 5rem; }
.m-t-8 { margin-top: 8rem; }
.m-t-10 { margin-top: 10rem; }

.m-b-0 { margin-bottom: 0rem; }
.m-b-1 { margin-bottom: 1rem; }
.m-b-3 { margin-bottom: 3rem; }
.m-b-5 { margin-bottom: 5rem; }
.m-b-8 { margin-bottom: 8rem; }
.m-b-10 { margin-bottom: 10rem; }


.m-r-0 { margin-right: 0rem; }
.m-r-1 { margin-right: 1rem; }
.m-r-3 { margin-right: 3rem; }
.m-r-5 { margin-right: 5rem; }
.m-r-8 { margin-right: 8rem; }
.m-r-10 { margin-right: 10rem; }

.btn {
  display: inline-block;
  text-decoration: none;
  border: none;
  transition: all .2s ease;
  padding: .5rem .7rem;
  box-shadow: 0px 5px 4px -1px rgba(0,0,0,.3);
  transform: translateY(2px);
  cursor: pointer;
}
.btn-primary {
  background: linear-gradient(160deg, hsla(232, 35%, 64%, 1), hsla(232, 35%, 41%, 1));
  color: #fff;
}
.btn-primary:hover {
  transform: translateY(0);
  box-shadow: 0px 4px 10px 1px rgba(0,0,0,.3);
}
.btn-secondary {
  background: #fff;
  box-shadow: 0px 1px 2px 2px rgba(255,255,255,1), 0px 1px 5px 3px rgba(0,0,0,.18), inset 0px 0px 0px 0px rgba(0,0,0,.2);
  border-radius: 10px;
  border: 1px solid rgba(0,0,0,0.2);
}
.btn-secondary:hover {
  box-shadow: 0px 0px 0px 2px rgba(255,255,255,1), 0px 1px 6px 6px rgba(0,0,0,.09), inset 0px 0px 6px 0px rgba(0,0,0,.2);
}

@media screen and (max-width: 1024px) {
  body { height: 100%; }
}
</style>
